import { GetLoginAnnouncementTableData } from '@/modules/client-setting/type'
import { ColumnDef } from '@tanstack/react-table'
import UpdateLoginAnnounce from './CellAction/UpdateLoginAnnounce'
import { IsActiveAnnounce } from './CellAction/IsActive'
import DeleteLoginAnnounce from './CellAction/DeleteLoginAnnounce'

export const columns: ColumnDef<GetLoginAnnouncementTableData>[] = [
	{
		accessorKey: 'order',
		header: 'ลำดับ',
	},
	{
		accessorKey: 'title',
		header: 'หัวข้อ',
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => <IsActiveAnnounce row={row.original} />,
	},
	{
		accessorKey: 'link',
		header: 'ลิงก์',
	},
	{
		accessorKey: 'targetPaths',
		header: 'แสดงที่หน้า',
		cell: ({ row }) =>
			(row.original.targetPaths?.length ?? 0) > 0
				? row.original.targetPaths?.join(', ')
				: 'หน้าแรกหลังเข้าสู่ระบบ',
	},
	{
		id: 'action',
		header: 'จัดการ',
		cell: ({ row }) => (
			<div className="flex items-center gap-1">
				<UpdateLoginAnnounce data={row.original} />
				<DeleteLoginAnnounce id={row.original.id} />
			</div>
		),
	},
]

export const writeAccessorKeys = ['isActive', 'action']
